import React from 'react';
import { motion } from 'framer-motion';
import Navbar from '../components/Navbar';

const ContactPage = () => {
  return (
    <>
      <Navbar />

      <section className="mb-20 py-20 sm:py-16 bg-gray-100">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-10 items-start">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-5 sm:space-y-6"
          >
            <h2 className="text-xl sm:text-2xl font-bold text-gray-800">Contact Us</h2>
            <p className="text-gray-700 text-sm sm:text-base leading-relaxed">
              📍 <strong>Registered & Corporate Office:</strong><br />
              No 3-58/4, Sumohana Conclave, Pelatottu,<br />
              Kalmanja Post & Village, Belthangady TQ,<br />
              Dakshina Kannada, Mangalore 574228
            </p>
            <p className="text-gray-700 text-sm sm:text-base">
              🌐 <a href="https://www.ceyone.org" className="text-blue-600 hover:underline" target="_blank" rel="noopener noreferrer">www.ceyone.org</a>
            </p>
            <p className="text-gray-700 text-sm sm:text-base">📧 hr.council@ceyone.org</p>
            <p className="text-gray-700 text-sm sm:text-base">📧 support@ceyone.org</p>
            <p className="text-gray-700 text-sm sm:text-base">📞 9448441531</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <iframe
              title="Ceyone Location"

              src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3887.529096974909!2d75.34218807507705!3d13.001942987316193!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2s!5e0!3m2!1sen!2sin!4v1750077144093!5m2!1sen!2sin"
           
              className="w-full h-64 sm:h-72 rounded-lg shadow-md"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
